import { useQuery } from "@tanstack/react-query"
import { Address, zeroAddress } from "viem"
import { paths } from "../apiTypes"

export type EarnVaultResponse =
  paths["/v1/earn/vault"]["get"]["responses"]["200"]["content"]["application/json"]

export function useEarnVaultIndexer<TData = EarnVaultResponse>({
  chainId,
  address,
  select,
  enabled = true,
}: {
  chainId: number
  address: Address
  select?: (data: EarnVaultResponse) => TData
  enabled?: boolean
}) {
  if (!process.env.NEXT_PUBLIC_EULER_API_URL) {
    throw new Error("NEXT_PUBLIC_EULER_API_URL is not set")
  }

  return useQuery<EarnVaultResponse, Error, TData>({
    queryKey: ["earnVaultsIndexer", chainId, address],
    queryFn: async () => {
      const params = new URLSearchParams({
        chainId: chainId?.toString() ?? "0",
        vaultAddress:
          address?.toString() ?? "0x0000000000000000000000000000000000000000",
      })
      const url = `${
        process.env.NEXT_PUBLIC_EULER_API_URL
      }/v1/earn/vault?${params.toString()}`

      const response = await fetch(url)
      if (!response.ok) {
        return response.json()
      }
      return response.json()
    },
    select: (data) => (select ? select(data) : (data as TData)),
    enabled: enabled && !!chainId && !!address && address !== zeroAddress,
  })
}
